import graphql__e123b7975ac3789e6537 from "./__generated__/ContributionCard_contribution.graphql.js";import { graphql, useFragment } from "react-relay";
import { useDispatch } from "react-redux";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import UserAvatar from "../../Users/UserAvatar";
import UserAuthorName from "../../Users/UserAuthorName";
import ReactableMeasures from "./ReactableMeasures";
import { highlight } from "../../../helpers/StringHelper";
import Icon from "../../Utils/Icon";
import {
  RESOURCES_LIST_CONTRIBUTION_TYPE,
  useResourcesList
} from "../../ResourcesList/resourcesList";
import ContributionThemesLabel from "./ContributionThemesLabel";
import Tooltip from "../../Tooltip/Tooltip";
import { isResourcesListItemSelected } from "../../Utils/resourcesList";
import { useFormatMessage } from "../../Intl/Context";

import { selectItem } from "../../../reducers/resourcesList/selection";
import ButtonDiv from "../../Buttons/ButtonDiv";

const ContributionCard = ({ showUnlocatedIndicator = false, ...props }) => {
  const contribution = useFragment(ContributionCard_contribution, props.contribution);
  const { id, title, author, themes, hasLocation, isFromAdminUser } = contribution;

  const resourcesList = useResourcesList();
  const { resourcesListKey, search } = resourcesList;
  const searchTerms = search?.terms;
  const isSelected = isResourcesListItemSelected(resourcesList, {
    id,
    type: RESOURCES_LIST_CONTRIBUTION_TYPE
  });

  showUnlocatedIndicator = showUnlocatedIndicator && !hasLocation;

  const t = useFormatMessage();
  const unlocatedHint = t(intlMessages.unlocatedHint);

  const dispatch = useDispatch();
  const selectResourcesListItem = () =>
    dispatch(selectItem(resourcesListKey, id, RESOURCES_LIST_CONTRIBUTION_TYPE));
  const handleClick = props.onClick || selectResourcesListItem;

  const highlightSearch = string => highlight(string, searchTerms);

  const className = classNames(
    "contribution-card",
    "position-relative",
    "box",
    "padding-x-sm",
    "padding-y-md",
    "d-flex",
    "align-items-center",
    "btn",
    "btn-unstyled",
    "w-100",
    {
      "box-selected": isSelected,
      "admin-highlight": isFromAdminUser
    }
  );

  return (
    <li className="list-unstyled margin-y-xs" data-contribution-card>
      <article>
        <ButtonDiv className={className} onClick={handleClick} isActive={!!isSelected}>
          <div className="d-flex flex-column align-items-center">
            <UserAvatar
              className="contribution-author-avatar margin-right-sm"
              user={author}
            />

            {showUnlocatedIndicator && (
              <div className="text-center margin-top-sm margin-right-sm">
                <Tooltip content={unlocatedHint} placement="right">
                  <Icon className="icon-unlocated text-primary text-sign-sm" />
                </Tooltip>
              </div>
            )}
          </div>

          <div className="flex-1">
            <UserAuthorName user={author} name={highlightSearch(author.name)} />

            <div className="text-title-overview-sm margin-y-xxs">
              {highlightSearch(title)}
            </div>

            <ContributionThemesLabel themes={themes} className="margin-bottom-xxs" />

            <ReactableMeasures reactable={contribution} />
          </div>
        </ButtonDiv>
      </article>
    </li>
  );
};

const ContributionCard_contribution = graphql__e123b7975ac3789e6537;

export default ContributionCard;

const intlMessages = defineMessages({
  unlocatedHint: {
    id: "contributions.card.unlocatedHint",
    defaultMessage: "Cette contribution n'est pas localisée sur la carte"
  }
});
